import { walletManageServer } from "server";
import { API } from "server/class";
import {
  CurrencyFromServer,
  Currency,
  MicroChainFromServer,
  MicroChain,
} from "./type";
import { camelCase } from "../../utils/commonUtils";
import joi from "joi";

export const getCurrencyAPI = new API<
  // REQUEST_TYPE
  {
    query: {
      microChainId?: number;
      microChainCurrencyIds?: number[];
      type?: number[];
      originOwnerId?: number;
      contractAddress?: string[];
    };
  },
  // RESPONSE_TYPE
  CurrencyFromServer[],
  // PARSED_RESPONSE_TYPE
  Currency[]
>({
  serverInstance: walletManageServer,
  url: "/v2/wallet-manage/micro-chain-currency",
  method: "get",
  requestValidator: joi.object({
    query: joi.object({
      microChainId: joi.number(),
      microChainCurrencyIds: joi.array().items(joi.number()),
      type: joi.array().items(joi.number()),
      originOwnerId: joi.number(),
      contractAddress: joi.array().items(joi.string()),
    }),
  }),
  responseParser: camelCase,
});

export const getMicroChainsAPI = new API<
  // REQUEST_TYPE
  {
    query: {
      networkId?: number;
      microChainId?: number;
      isDefault?: boolean;
      isExternal?: boolean;
    };
  },
  // RESPONSE_TYPE
  MicroChainFromServer[],
  // PARSED_RESPONSE_TYPE
  MicroChain[]
>({
  serverInstance: walletManageServer,
  url: "/v2/wallet-manage/micro-chains",
  method: "get",
  requestValidator: joi.object({
    query: joi.object({
      networkId: joi.number(),
      microChainId: joi.number(),
      isDefault: joi.boolean(),
      isExternal: joi.boolean(),
    }),
  }),
  responseParser: camelCase,
});
